import { useState } from 'react';

const PopularToursSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const tours = [
    {
      id: 1,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Arkhangelsk/Golubino_partner/golubino.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Знакомство с Русским Севером',
      description: '3 дня в заповедной сказке ландшафтного парка Голубино, д. Красная горка, водопад и карстовая пещера',
      date: '01.11.2025 – 31.12.2025',
      price: 'от 7 500 ₽',
      tag: 'Осталось 8 мест',
      link: 'https://mirsg.ru/ru/catalog/travel/3-dnya-v-arhangelskoj-oblasti'
    },
    {
      id: 2,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Sheregesh/Sheregesh_partner/timur-team-193.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Горнолыжный тур в Шерегеш',
      description: 'Катание под руководством профессионалов. Авторская кухня. Уютные вечера. Ежедневная сибирская баня',
      date: '29.11.2025 – 03.01.2026',
      price: '89900 ₽',
      tag: 'Новый маршрут',
      link: 'https://mirsg.ru/ru/catalog/travel/sheregesh-2'
    },
    {
      id: 3,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Belarus/minsk-20240913.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Белорусский калейдоскоп',
      description: 'За 5 дней - 9 экскурсий, прогулки по Минску и Несвижу, парки-музеи, дегустации. Все включено',
      date: '10.12.2025 – 01.02.2026',
      price: 'от 47 700 ₽',
      tag: 'С гидом Анной С.',
      link: 'https://mirsg.ru/ru/catalog/travel/nasycshennyj-tur-v-belorussiyu-6'
    },
    {
      id: 4,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Tanzania/istock-1147742318-kilimangjaro.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Восхождение на Килиманджаро',
      description: 'Восхождение с комфортной акклиматизацией. Продление отдыха сафари в Танзании и на пляжах Занзибара',
      date: '12.12.2025 – 22.12.2025',
      price: '2240 $',
      tag: 'Осталось 8 мест',
      link: 'https://mirsg.ru/ru/catalog/travel/kilimandzharo-voshozhdenie-po-marshrutu-lemosho-1'
    },
    {
      id: 5,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Belarus/Tur-8-dnej/nesviz-oblozka.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Тайны Несвижского замка',
      description: 'Насыщенный трехдневный тур: 9 экскурсий, ночлег в старинном замке, парки, музеи и костелы. Все включено',
      date: '12.12.2025 – 14.12.2025',
      price: 'от 26 300 ₽',
      tag: 'Новый маршрут',
      link: 'https://mirsg.ru/ru/catalog/travel/tur-v-minsk-i-nesvizhskij-zamok-4'
    },
    {
      id: 6,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Belarus/Foto_partner_Viapol/vitebsk-uspenskay-gorka-1.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Живописный Витебск',
      description: '4-дневный тур по Белоруссии: 11 экскурсий, посещение храмов, музеев, усадеб. Все включено',
      date: '18.12.2025 – 21.12.2025',
      price: 'от 37 500 ₽',
      tag: 'Осталось 2 места',
      link: 'https://mirsg.ru/ru/catalog/travel/minsk-vitebsk-i-polock'
    },
    {
      id: 7,
      image: 'https://mirsg.ru/thumb/shared/upload/IMAGES/Directions/Sokotra/Istock-msg/Obl/istock-495699137-2.jpg&w=240&h=150&f=jpeg&q=100&zc=1&far=0',
      title: 'Новогодний тур на Сокотру',
      description: 'Встреча Нового года на острове. Треккинги по песчаным дюнам, драконовые деревья и коралловые рифы',
      date: '26.12.2025 – 02.01.2026',
      price: '2250 $',
      tag: 'С гидом Анной С.',
      link: 'https://mirsg.ru/ru/catalog/travel/tur-na-sokotru-new-year'
    }
  ];

  const slidesPerView = 4;
  const totalSlides = tours.length;
  const maxSlide = totalSlides - slidesPerView;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= maxSlide ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? maxSlide : prev - 1));
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="bg-white py-20">
      <div className="max-w-[1360px] mx-auto px-6">
        <h2 className="font-mulish font-bold text-3xl text-gray-900 mb-12">
          Популярные туры
        </h2>

        <div className="relative">
          {/* Слайдер */}
          <div className="overflow-hidden">
            <div
              className="flex gap-6 transition-transform duration-500 ease-in-out"
              style={{ 
                transform: `translateX(calc(-${currentSlide * 25}% - ${currentSlide * 1.5}rem))` 
              }}
            >
              {tours.map((tour) => (
                <div
                  key={tour.id}
                  className="w-[calc(25%-1.125rem)] flex-shrink-0"
                >
                  <a
                    href={tour.link}
                    className="flex flex-col h-full bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-gray-300 transition-all duration-300 group cursor-pointer"
                    style={{
                      transition: 'background-color 0.3s ease, border-color 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f0f8ff70';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#ffffff';
                    }}
                  >
                    {/* Изображение */}
                    <div className="relative h-48 overflow-hidden flex-shrink-0">
                      <img
                        src={tour.image}
                        alt={tour.title}
                        className="w-full h-full object-cover object-top"
                      />
                      {/* Тег */}
                      <div className="absolute top-3 right-3 bg-white px-3 py-1 rounded-full shadow-sm">
                        <span className="font-open-sans text-xs text-gray-700">
                          {tour.tag}
                        </span>
                      </div>
                    </div>

                    {/* Контент */}
                    <div className="p-5 flex flex-col flex-grow">
                      <h3
                        className="font-mulish font-bold text-lg text-gray-900 mb-3 transition-colors duration-300"
                        style={{
                          transition: 'color 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          if (e.currentTarget.closest('a:hover')) {
                            e.currentTarget.style.color = '#0D47A1';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = '#111827';
                        }}
                      >
                        {tour.title}
                      </h3>

                      <p className="font-open-sans text-sm text-gray-600 mb-4 line-clamp-3 leading-relaxed flex-grow">
                        {tour.description}
                      </p>

                      <div className="flex items-center justify-between mb-4">
                        <span className="font-open-sans text-xs text-gray-500">
                          {tour.date}
                        </span>
                      </div>

                      <div className="flex items-center justify-between mt-auto">
                        <span className="font-mulish font-bold text-xl text-[#1E88E5]">
                          {tour.price}
                        </span>
                        <button className="font-open-sans text-sm text-white bg-[#1E88E5] hover:bg-[#0D47A1] font-semibold px-4 py-2 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer">
                          Подробнее
                        </button>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Навигация и пагинация */}
          <div className="flex items-center justify-between mt-8">
            {/* Пагинация (точки) - слева */}
            <div className="flex items-center gap-2">
              {Array.from({ length: maxSlide + 1 }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    currentSlide === index
                      ? 'bg-blue-600 w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Перейти к слайду ${index + 1}`}
                />
              ))}
            </div>

            {/* Кнопки навигации - справа */}
            <div className="flex items-center gap-3">
              <button
                onClick={prevSlide}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f3f4f6] hover:bg-[#0D47A1] transition-colors duration-300 cursor-pointer group"
                aria-label="Предыдущий слайд"
              >
                <i className="ri-arrow-left-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
              </button>
              <button
                onClick={nextSlide}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f3f4f6] hover:bg-[#0D47A1] transition-colors duration-300 cursor-pointer group"
                aria-label="Следующий слайд"
              >
                <i className="ri-arrow-right-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularToursSection;
